// An analyst's word on the case graph's facts (PRD-0075 R-C3, R-C4, ADR-0093): *Pridať fakt*,
// *Už neplatí od*, *Chybné*, and their undo. Entities by stable `_uid`, relationships by the
// element id the graph view holds them under. Each answer is the node or edge as the mark left it.
import { apiClient } from './client'

/** An asserted value: one flat scalar. */
export type FactValue = string | number | boolean

interface FactSourceFields {
  source_text?: string | null
  source_document_id?: string | null
}

export interface AssertFactRequest extends FactSourceFields {
  key: string
  value: FactValue
  /** ISO dates (YYYY-MM-DD), both inclusive. */
  valid_from?: string | null
  valid_to?: string | null
}

export interface InvalidateFactRequest extends FactSourceFields {
  /** ISO date (YYYY-MM-DD). */
  invalid_from: string
  reason: string
}

export interface RetireRequest {
  reason: string
}

/** The node or edge as the mark left it (`MarkedGraphItem`). */
export interface MarkedGraphItem {
  id: string
  properties: Record<string, unknown>
}

const graph = (caseId: string) => `/v1/cases/${caseId}/graph`
const entity = (caseId: string, uid: string) =>
  `${graph(caseId)}/entities/${encodeURIComponent(uid)}`
const relationship = (caseId: string, id: string) =>
  `${graph(caseId)}/relationships/${encodeURIComponent(id)}`
const property = (caseId: string, uid: string, key: string) =>
  `${entity(caseId, uid)}/properties/${encodeURIComponent(key)}`

export const analystFactsApi = {
  assertFact: (caseId: string, uid: string, body: AssertFactRequest) =>
    apiClient.post<MarkedGraphItem>(`${entity(caseId, uid)}/facts`, body),

  invalidateProperty: (caseId: string, uid: string, key: string, body: InvalidateFactRequest) =>
    apiClient.put<MarkedGraphItem>(`${property(caseId, uid, key)}/invalidation`, body),
  revalidateProperty: (caseId: string, uid: string, key: string) =>
    apiClient.delete<MarkedGraphItem>(`${property(caseId, uid, key)}/invalidation`),

  invalidateRelationship: (caseId: string, id: string, body: InvalidateFactRequest) =>
    apiClient.put<MarkedGraphItem>(`${relationship(caseId, id)}/invalidation`, body),
  revalidateRelationship: (caseId: string, id: string) =>
    apiClient.delete<MarkedGraphItem>(`${relationship(caseId, id)}/invalidation`),

  retireEntity: (caseId: string, uid: string, body: RetireRequest) =>
    apiClient.put<MarkedGraphItem>(`${entity(caseId, uid)}/retirement`, body),
  restoreEntity: (caseId: string, uid: string) =>
    apiClient.delete<MarkedGraphItem>(`${entity(caseId, uid)}/retirement`),

  retireRelationship: (caseId: string, id: string, body: RetireRequest) =>
    apiClient.put<MarkedGraphItem>(`${relationship(caseId, id)}/retirement`, body),
  restoreRelationship: (caseId: string, id: string) =>
    apiClient.delete<MarkedGraphItem>(`${relationship(caseId, id)}/retirement`),
}
